import { useSelector } from "react-redux";
import BriefcaseIconWhiteBG from "../../assets/images/BriefcaseIconWhiteBG";
import { Constants } from "../../constants/constants";
import { RootState } from "../../store/store";
import { getFormattedDate } from "../../utils/DataTime";
import CameraIcon from "../../assets/images/CameraIcon";
import Avatar from "../../assets/images/profile2.svg";

export const UserProfile = ({
  getUserValidationStatus,
  jsonObjData,
  isAndroid = false,
}: any) => {
  const userDetailJsonObj = useSelector(
    (state: RootState) =>
      state.userOnboardingJsonDetails?.userDetailResponseWithFaceAttribute
  );

  let userValidationStatus = getUserValidationStatus(
    jsonObjData?.consentStatus,
    jsonObjData?.ekycStatus,
    isAndroid
  );

  const userName =
    jsonObjData?.formSegments[0]?.subSegments[0]?.attributes[0]?.value;
  const userRoles = Object.values(jsonObjData?.valueMap?.roleId || {}).join(
    ","
  );

  return (
    <div className="flex justify-start ">
      <div className="mr-2  bg-sideMenuInRegisterUserBackground rounded-lg flex justify-center items-center ">
        {userDetailJsonObj ? (
          userDetailJsonObj.formSegments
            .flatMap((segment: any) => segment.subSegments)
            .flatMap((subSegment: any) => subSegment.attributes)
            .filter((attribute: any) => attribute.name === "face")
            .map((attribute: any) => (
              <div className="" key={attribute.attributeId}>
                {
                
                !attribute?.value || attribute.value.trim() == "" ?
                  <img
                  src={Avatar}
                  alt="User Face "
                  className={`${
                    isAndroid ? "w-24" : "w-72"
                  } h-30 object-cover rounded-lg border border-gray-300`}
                />
                :
                <img
                  src={attribute.value}
                  alt="User Face"
                  className={`${
                    isAndroid ? "w-24" : "w-72"
                  } h-24 object-cover rounded-lg border border-gray-300`}
                />
                }
              </div>
            ))
        ) : (
          <CameraIcon />
        )}
      </div>
      <div className="px-1 flex flex-col">
        <div className="flex">
          <div
            className={`${
              isAndroid ? "selectedRoleButton" : "h5"
            } text-black font-poppins  `}
          >
            {userName}
          </div>

          <div
            className={`flex items-center  ml-3 px-2 text-center  border border-resendConsentButtonBorderColor rounded-xl  w-fit ${userValidationStatus.backGroundColor} gap-1 `}
          >
            {userValidationStatus.icon}
            <div
              className={`${isAndroid ? "status " : "smallText"}  ${
                userValidationStatus.textColor
              } font-nunito  whitespace-nowrap`}
            >
              {userValidationStatus?.status}
            </div>
          </div>
        </div>

        <div className="py-1 flex justify-start">
          <BriefcaseIconWhiteBG
            height={isAndroid ? "16px" : "24px"}
            width={isAndroid ? "16px" : "24px"}
          />
          <div
            className={`px-2 text-black ${
              isAndroid ? "consentRefreshDescription" : "roleText"
            } font-nunito`}
          >
            <span>{userRoles}</span>
          </div>
        </div>
        {/* {userDetail?.professionalDetails?.employeeId && ( */}
        <div
          className={`text-body1Regular  ${
            isAndroid ? "consentRefreshDescription" : "roleText"
          } font-nunito`}
        >
          {jsonObjData?.employeeId === null ||
          jsonObjData?.employeeId === undefined ||
          jsonObjData?.employeeId === "null"
            ? `${Constants.Id} NA`
            : `${Constants.Id}${jsonObjData?.employeeId}`}
        </div>
        {/* )} */}
        <div
          className={` text-popUpTitleColor ${
            isAndroid ? "accountText" : "quickLinksDescription"
          }`}
        >
          {`${Constants.AccountCreatedOn} ${getFormattedDate(
            jsonObjData?.createdAt ?? "2024/02/12"
          )}`}
        </div>
      </div>
    </div>
  );
};
